// extracted by mini-css-extract-plugin
export default {"preview":"MarketplaceNewPreview_preview__CzfIb"};